import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EaPipesModule } from '@app/pipes/ea-pipes.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SwiperOptions } from 'swiper';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrPanelModule } from '../pr-panel/pr-panel.module';
import { PrProgressModule } from '../pr-progress/pr-progress.module';
import { PrSelectModule } from '../pr-select/pr-select.module';
import {
  APP_SWIPER_CONFIG,
  PrSwiperModule,
} from '../pr-swiper/pr-swiper.module';
import { PrPaginationComponent } from './pr-pagination/pr-pagination.component';
import { PrTableComponent } from './pr-table.component';

const DEFAULT_SWIPER_CONFIG: SwiperOptions = {
  observer: true,
  direction: 'horizontal',
  threshold: 50,
  spaceBetween: 5,
  wrapperClass: 'pr-wrapper',
  slidesPerView: 1,
  centeredSlides: true,
};

@NgModule({
  declarations: [PrTableComponent, PrPaginationComponent],
  imports: [
    CommonModule,
    PrPanelModule,
    PrProgressModule,
    PrIconModule,
    EaPipesModule,
    TooltipModule,
    PrSelectModule,
    PrSwiperModule,
  ],
  exports: [PrTableComponent, PrPaginationComponent],
  providers: [
    {
      provide: APP_SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class PrTableModule {}
